import {
  Button,
  Divider,
  Form,
  Input,
  Select,
  message,
  notification,
  Upload,
  Modal,
  DatePicker,
} from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { callRegister } from "../../../config/api";
import styles from "./auth.module.scss";
import { IUser } from "../../../types/backend";
import ImgCrop from "antd-img-crop";
import noAvatar from "../../../assets/images/no_image.jpg";
import type { UploadFile, UploadProps } from "antd";
import { UploadOutlined } from "@ant-design/icons";
type FileType = Parameters<any>[0];

const { Option } = Select;

const getBase64 = (file: any): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const RegisterPage = () => {
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile[]>([]); // Khởi tạo fileList rỗng

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };

  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    // Giữ chỉ một tệp trong fileList
    setFileList(newFileList.slice(-1));
  };

  const onFinish = async (values: IUser) => {
    const avatar: any =
      fileList.length === 1 ? fileList[0]?.thumbUrl : noAvatar;
      values.status = false
    const { name, email, password, date_of_birth, gender, address, status } = values;


    setIsSubmit(true);
    const res = await callRegister(
      name,
      email,
      password as string,
      date_of_birth,
      gender,
      address,
      avatar,
      status
    );
    setIsSubmit(false);
    if (res?.data?._id) {
      message.success("Đăng ký tài khoản thành công!");
      navigate("/login");
    } else {
      notification.error({
        message: "Có lỗi xảy ra",
        description:
          res.message && Array.isArray(res.message)
            ? res.message[0]
            : res.message,
        duration: 5,
      });
    }
  };

  return (
    <div className={styles["register-page"]}>
      <main className={styles.main}>
        <div className={styles.container}>
          <section className={styles.wrapper}>
            <div className={styles.heading}>
              <h2 className={`${styles.text} ${styles["text-large"]}`}>
                {" "}
                Đăng Ký Tài Khoản{" "}
              </h2>
              <Divider />
            </div>
            <Form<IUser>
              name="basic"
              // style={{ maxWidth: 600, margin: '0 auto' }}
              onFinish={onFinish}
              autoComplete="off">
              <Form.Item
                labelCol={{ span: 24 }} //whole column
                label="Họ tên"
                name="name"
                rules={[
                  { required: true, message: "Họ tên không được để trống!" },
                  { min: 3, message: "Họ tên phải có ít nhất 3 ký tự!" },
                ]}>
                <Input />
              </Form.Item>

              <Form.Item
                labelCol={{ span: 24 }} //whole column
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Email không được để trống!" },
                  { type: "email", message: "Email không đúng định dạng!" },
                ]}>
                <Input type="email" />
              </Form.Item>

              <Form.Item
                labelCol={{ span: 24 }} //whole column
                label="Mật khẩu"
                name="password"
                rules={[
                  { required: true, message: "Mật khẩu không được để trống!" },
                  { min: 6, message: "Mật khẩu phải có ít nhất 6 ký tự!" },
                ]}>
                <Input.Password />
              </Form.Item>
              <Form.Item
                labelCol={{ span: 24 }} //whole column
                label="Ngày sinh"
                name="date_of_birth"
                rules={[
                  { required: true, message: "Tuổi không được để trống!" },
                ]}>
                <DatePicker
                  style={{ width: "100%" }}
                  defaultValue={undefined}
                  format={"DD/MM/YYYY"}
                  placeholder="DD/MM/YYYY"
                />
              </Form.Item>

              <Form.Item
                labelCol={{ span: 24 }} //whole column
                name="gender"
                label="Giới tính"
                rules={[
                  { required: true, message: "Giới tính không được để trống!" },
                  {
                    type: "enum",
                    enum: ["male", "female", "other"],
                    message: "Giới tính không hợp lệ!",
                  },
                ]}>
                <Select
                  // placeholder="Select a option and change input text above"
                  // onChange={onGenderChange}
                  allowClear>
                  <Option value="male">Nam</Option>
                  <Option value="female">Nữ</Option>
                  <Option value="other">Khác</Option>
                </Select>
              </Form.Item>

              <Form.Item
                labelCol={{ span: 24 }} //whole column
                label="Địa chỉ"
                name="address"
                rules={[
                  { required: true, message: "Địa chỉ không được để trống!" },
                  { min: 6, message: "Địa chỉ phải có ít nhất 6 ký tự!" },
                ]}>
                <Input />
              </Form.Item>

              <Form.Item
                // labelCol={{ span: 24 }} //whole column
                name="avatar"
                label="Ảnh đại diện"
                className="register-form-item">
                <ImgCrop quality={1} aspect={35 / 35}>
                  <Upload
                    action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}>
                    {fileList.length === 0 && (
                      <div>
                        <UploadOutlined /> Tải ảnh lên
                      </div>
                    )}
                  </Upload>
                </ImgCrop>
                <Modal
                  open={previewOpen}
                  title={previewTitle}
                  footer={null}
                  onCancel={handleCancel}>
                  <img
                    alt="example"
                    style={{ width: "100%" }}
                    src={previewImage}
                  />
                </Modal>
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={isSubmit}>
                  Đăng ký
                </Button>
              </Form.Item>
              <Divider> Or </Divider>
              <p className="text text-normal">
                {" "}
                Đã có tài khoản ?
                <span>
                  <Link to="/login"> Đăng Nhập </Link>
                </span>
              </p>
            </Form>
          </section>
        </div>
      </main>
    </div>
  );
};

export default RegisterPage;
